export enum ChartLegendPosition {
    bottom,
    left,
    in,
    none,
    right,
    top
}